<template>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="pageSetting.pageTitle" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-16">
                <div class="f-regular f-12 f-c-green m-d-4">
                    Setoran dari Outlet
                </div>
                <div class="f-bold f-18 f-c-black m-d-8">
                    Setoran Kas dari {{ setoran.detail_keuangan_transfer.nama_outlet }}
                </div>
                <div class="f-regular f-12 f-c-midgrey">
                    <img src="@/assets/icons/clock.svg" alt="" />
                    <span class="m-l-4">
                        Disetor {{ rawFormatDate(setoran.detail_keuangan_transfer.waktu_created_raw) }} oleh
                        {{ setoran.detail_keuangan_transfer.nama_karyawan }}
                    </span>
                </div>
            </div>

            <div class="separator-line-dot"></div>

            <div
                v-if="setoran.detail_keuangan_transfer.status !== 1"
                class="p-x-20 p-y-12"
                :class="{
                    'setoran-disetujui': setoran.detail_keuangan_transfer.status === 2,
                    'setoran-ditolak': setoran.detail_keuangan_transfer.status === 3,
                }"
            >
                <div class="f-c-green" v-if="setoran.detail_keuangan_transfer.status === 2">
                    <span class="f-semi f-14">Setoran Disetujui </span>
                    <span class="f-semi f-12">({{ rawFormatDate(setoran.detail_keuangan_transfer.waktu_status_raw )}})</span>
                </div>
                <div class="f-c-red" v-if="setoran.detail_keuangan_transfer.status === 3">
                    <span class="f-semi f-14">Setoran Ditolak </span>
                    <span class="f-semi f-12">({{ rawFormatDate(setoran.detail_keuangan_transfer.waktu_status_raw) }})</span>
                </div>
                <div class="f-regular f-13" v-if="setoran.detail_keuangan_transfer.keterangan_status !== ''">
                    <span class="f-c-midgrey">Catatan: </span>
                    <span class="f-c-black">
                        {{ setoran.detail_keuangan_transfer.keterangan_status }}
                    </span>
                </div>
            </div>

            <div class="p-x-20 p-y-16">
                <div class="d-flex-between-center m-d-8">
                    <div class="f-regular f-16 f-c-midgrey">
                        Dari akun
                    </div>
                    <div class="f-regular f-16 f-c-black">
                        {{ setoran.detail_keuangan_transfer.nama_akun_kredit }}
                    </div>
                </div>
                <div class="d-flex-between-center m-d-8">
                    <div class="f-regular f-16 f-c-midgrey">
                        Penanggung jawab
                    </div>
                    <div class="f-regular f-16 f-c-black">
                        {{ setoran.detail_keuangan_transfer.nama_karyawan }}
                    </div>
                </div>
                <div class="p-y-8 m-d-8">
                    <div class="card-setoran">
                        <div class="f-regular f-14 f-c-midgrey">
                            Disetor ke akun:
                        </div>
                        <div class="d-flex-between-center m-t-4" v-for="(tujuan, i) in setoran.tujuan_setor" :key="i">
                            <div class="f-regular f-14 f-c-black">
                                {{ tujuan.nama_akun }}
                            </div>
                            <div class="f-regular f-14 f-c-black">Rp. {{ formatRupiah(tujuan.nominal) }}</div>
                        </div>
                        <div class="d-flex-between-center m-t-4 border-top p-t-8">
                            <div class="f-regular f-14 f-c-midgrey">
                                Total
                            </div>
                            <div class="f-regular f-14 f-c-midgrey">
                                Rp. {{ formatRupiah(setoran.detail_keuangan_transfer.total_setoran) }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="f-regular f-14 f-c-midgrey" v-if="setoran.detail_keuangan_transfer.keterangan !== ''">
                    Keterangan
                </div>
                <div class="f-regular f-14 f-c-black" v-if="setoran.detail_keuangan_transfer.keterangan !== ''">
                    {{ setoran.detail_keuangan_transfer.keterangan }}
                </div>
            </div>

            <div class="separator"></div>

            <div class="p-x-20 p-y-16" style="margin-bottom: 72px">
                <div class="p-d-12">
                    <div class="f-semi f-16 f-c-black">Ringkasan Keuangan</div>
                    <div class="f-regular f-13 f-c-midgrey">
                        Dihitung sejak setoran sebelumnya hingga setoran ini.
                    </div>
                </div>
                <div class="card-setoran">
                    <div class="d-flex-between-center p-y-8" :class="{ 'border-bottom': true }">
                        <div class="f-regular f-14 f-c-midgrey text-capitalize">
                            Tanggal
                        </div>
                        <div class="f-regular f-14 f-c-black">{{ tanggal }}</div>
                    </div>
                    <div class="d-flex-between-center p-y-8" :class="{ 'border-bottom': true }">
                        <div class="f-regular f-14 f-c-midgrey text-capitalize">
                            Transfer Terakhir
                        </div>
                        <div class="f-regular f-14 f-c-black">{{ lastTransfer }}</div>
                    </div>
                    <div v-for="(v, k) in ringkasanKeuangan" :key="v">
                        <div class="d-flex-between-center p-y-8" :class="{ 'border-bottom': true }" v-if="v !== null">
                            <div class="f-regular f-14 f-c-midgrey text-capitalize">
                                {{ k == "biaya_approve" ? "Biaya Disetujui" : k.replace("_", " ") }}
                            </div>
                            <div class="f-regular f-14 f-c-black">Rp {{ formatRupiah(v) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="setoran.detail_keuangan_transfer.status === 1 && validateAccess('cashDepositOutlet.confirm')"
                class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
                style="position: fixed; bottom: 64px"
            >
                <div class="btn_actions col-md-6 col-sm-6 col-6 pr-1">
                    <SOButton :outline="true" :full="true" :text="'Tolak'" @action="tolak" />
                </div>
                <div class="btn_actions col-md-6 col-sm-6 col-6 pl-1">
                    <SOButton :primary="true" :full="true" :text="'Setujui'" @action="setujui" />
                </div>
            </div>
            <div
                v-if="setoran.detail_keuangan_transfer.status !== 1 && validateAccess('cashDepositOutlet.delete')"
                class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
                style="position: fixed; bottom: 70px"
            >
                <div class="btn_actions col-md-12 col-sm-12 col-12">
                    <SOButton :outline-danger="true" :full="true" :text="'Hapus'" @action="onDelete" />
                </div>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "SetoranKasOutletDetail",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOButton,
    },
    computed: {
        ...mapGetters("setoranKasOutletModule", {
            setoran: "getSetoranKasOutletDetail",
        }),
        tanggal() {
			return this.$moment(this.setoran.ringkasan_keuangan.tanggal_long).local().format('YYYY-MM-DD HH:mm:ss');
        },
        lastTransfer() {
            if (this.setoran.ringkasan_keuangan.last_transfer_long == 0) {
                return '-';
            }
			return this.$moment(this.setoran.ringkasan_keuangan.last_transfer_long).local().format('YYYY-MM-DD HH:mm:ss');
        },
        ringkasanKeuangan() {
            let ringkasan = {
                ...this.setoran.ringkasan_keuangan,
            };
            ringkasan.last_transfer = null;
            ringkasan.last_transfer_long = null;
            ringkasan.tanggal = null;
            ringkasan.tanggal_long = null;

            return ringkasan;
        },
    },
    data() {
        return {
            idtransfer: "",
            pageSetting: {
                pageTitle: "Detail Setoran",
                loading: true,
            },
            isNotification: false
        };
    },
    mounted() {
        this.idtransfer = this.$route.params.id;
        this.detail();
        this.isNotification = this.$route.query.is_notification == "1"
        if(this.setoran.detail_keuangan_transfer.status===1){
            this.smartTrackingView("konfirmasi_setoran_kas_outlet");
        }else{
            this.smartTrackingView("detail_setoran_kas_outlet");
        }

    },
    methods: {
        async detail() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch(
                "setoranKasOutletModule/fetchSetoranKasOutletDetail",
                this.idtransfer
            );
            this.pageSetting.loading = false;
            if (!res.success) {
                this.$toast.error(res.err);
            }
        },
        back() {
            this.$router.back();
        },
        tolak() {
            this.$router.push({ name: "SetoranKasOutlet.Detail.Tolak", params: {isNotification: this.isNotification} });
            this.smartTrackingClick("tolak_setoran_kas_outlet");
        },
        setujui() {
            this.$router.push({ name: "SetoranKasOutlet.Detail.Setuju", params: {isNotification: this.isNotification} });
            this.smartTrackingClick("setuju_setoran_kas_outlet");

        },
        onDelete() {
            this.$router.push({ name: "SetoranKasOutlet.Detail.delete" });
            this.smartTrackingClick("hapus_setoran_kas_outlet");
        },
		rawFormatDate(date) {
			return this.$moment(date).format("DD MMM YYYY HH:mm");
		}
    },
};
</script>

<style scoped>
.card-setoran {
    border: 1px solid #c8d0dd;
    border-radius: 4px;
    padding: 10px 18px;
}

.setoran-disetujui {
    background-color: #e8fcee;
}

.setoran-ditolak {
    background-color: #fff1f1;
}
</style>
